import { NgModule } from "@angular/core";
import { Routes, RouterModule, PreloadAllModules } from "@angular/router";
import { AppComponent } from "./app.component";

const routes: Routes = [
  { path: "auth-gnc", component: AppComponent },
  { path: "gnc", loadChildren: "./pages/home/home.module#HomeModule" },
  { path: "", redirectTo: "auth-gnc", pathMatch: "full" }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
